import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Badge } from "@/components/ui/badge";

export const ProfilePage = () => {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="space-y-6" data-testid="profile-page">
      <div>
        <h1 className="font-display text-3xl font-bold">Profile</h1>
        <p className="text-[#8a8a8a] text-sm mt-1">Your Funded Index account details.</p>
      </div>
      <div className="glass rounded-xl p-6 max-w-2xl space-y-4">
        <div className="flex items-center gap-4 pb-5 border-b border-[#ff7a00]/15">
          <div className="w-16 h-16 rounded-full bg-[#ff7a00]/15 border border-[#ff7a00]/30 flex items-center justify-center text-[#ff7a00] font-display font-bold text-2xl">
            {(user.first_name?.[0] || user.email[0]).toUpperCase()}
          </div>
          <div>
            <div className="font-display text-xl font-bold">{user.first_name} {user.last_name}</div>
            <div className="text-[#8a8a8a] text-sm">{user.email}</div>
            <div className="mt-2 flex gap-2">
              {(user.roles || []).map((r) => (
                <Badge key={r} className="bg-[#ff7a00]/10 text-[#ff7a00] border-[#ff7a00]/30 uppercase text-[10px] tracking-widest">{r}</Badge>
              ))}
            </div>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <div className="text-[10px] text-[#8a8a8a] uppercase tracking-widest">Country</div>
            <div className="text-[#f5f5f5] mt-1">{user.country || "—"}</div>
          </div>
          <div>
            <div className="text-[10px] text-[#8a8a8a] uppercase tracking-widest">Joined</div>
            <div className="text-[#f5f5f5] mt-1">{new Date(user.created_at).toLocaleDateString()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
